import React, {Component} from 'react';
import '../App.css';


class Header extends Component {

    constructor(props) {
        super(props);
        this.GoToHome = this.GoToHome.bind(this);
        this.ShowMenu = this.ShowMenu.bind(this);
        this.Close = this.Close.bind(this);
        this.GoTo = this.GoTo.bind(this);

        this.state = {ShowMenu: false};

        this.language = global.api.ValidateLanguage(this.props.main.props.main.language);

    }

    GoToHome() {
        this.props.main.refs.router.history.push("/")
    }

    ShowMenu() {
        this.setState((prevState, props) => {
            return {ShowMenu: !prevState.ShowMenu};
        });
    }

    Close() {
        this.setState((prevState, props) => {
            return {CloseMenuReq: true};
        });


        setTimeout(() => {

            this.setState((prevState, props) => {
                return {CloseMenuReq: false, ShowMenu: false};
            });

        }, 400);
    }

    GoTo(rif) {
        this.Close();
        this.props.main.refs.router.history.push("/" + global.api.CurrentLanguage + "/" + rif)
    }


    render() {

        let SideMenu = false;

        if (this.state.ShowMenu) {

            let BgClassAnimation = "Side_ShowOpacity";
            let MenuClassAnimation = "Side_Show";

            if (this.state.CloseMenuReq === true) {
                BgClassAnimation = "Side_HideOpacity";
                MenuClassAnimation = "Side_Hide";
            }

            SideMenu = (
                <div className={"SideMenuBG " + BgClassAnimation}
                     onClick={(e) => {
                         e.stopPropagation();
                         this.Close();
                     }}
                >

                    <div className={"SideMenu " + MenuClassAnimation}
                         onClick={(e) => {
                             e.stopPropagation();
                         }}>
                        <div className={"MenuContent"}>

                            {global.api.menuItems.map((item, index) => {
                                let rif = item.rif;
                                let title = rif;
                                let link = rif;

                                try {
                                    title = global.api.pagesData[rif]["title"][global.api.CurrentLanguage];
                                }
                                catch (err) {
                                }

                                try {
                                    link = global.api.pages[rif][global.api.CurrentLanguage];
                                }
                                catch (err) {
                                }

                                const imageUrl = require('./images/' + item.icon);

                                return (
                                    <div
                                        key={index}
                                        className={"MenuRow"}
                                        onClick={() => {
                                            this.GoTo('app/' + link)
                                        }}
                                    >
                                        <div style={{width: '15px'}}/>
                                        <div className="MenuIcon" style={{
                                            backgroundImage: "url(" + imageUrl + ")"
                                        }}/>
                                        <div style={{width: '13px'}}/>
                                        <div>{title}</div>
                                    </div>
                                );
                            })}


                        </div>
                    </div>
                </div>

            );
        }

        let LogoImg = null;

        if (this.language === "it") {
            LogoImg = require('./logo.png');
        }
        else {
            LogoImg = require('./logo_en.png');
        }

        return (


            <div className="header">
                <div className="logo">
                    <div className="menu fa fa-bars" onClick={this.ShowMenu}/>
                    <img src={LogoImg} className="App-logo" onClick={this.GoToHome} alt="logo"/>
                </div>

                {SideMenu}
            </div>
        );
    }
}

export default Header;


/*
import logo from './logo.svg';

 <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
      </div>
 */


// WEBPACK FOOTER //
// ./src/include/Header.js